module.exports = __webpack_public_path__ + "static/media/orange_nebula_BK.444db7fb.png";